import {DROPDOWN_TYPES} from '@/utils/constants/dropdownConstants';
import {useDropdown} from './Dropdown-hook';
import {useMemo} from 'react';
import {ACTION_DROPDOWN} from '@/utils/constants/commonConstants';

export const useActionDropDown = () => {
  const {dropdownList} = useDropdown({dropdownType: DROPDOWN_TYPES.Actions});

  const dropdownListActions = useMemo(() => {
    if (!dropdownList?.length) return dropdownList;

    return dropdownList.map((item) =>
      item?.displayText === ACTION_DROPDOWN.REMOVE_NUM_POINTS_CHECK
        ? {...item, displayText: item.value}
        : item
    );
  }, [dropdownList]);
  return {dropdownList: dropdownListActions};
};
